import { z } from 'zod';
import { LocalDateSchema, StreakSchema } from './common';

export const RecapReviewSchema = z.object({
  id: z.uuid(),
  chapterId: z.string(),
  chapterSlug: z.string(),
  chapterTitle: z.string(),
  dueOn: LocalDateSchema,
});
export type RecapReview = z.infer<typeof RecapReviewSchema>;

export const RecapDueResponseSchema = z.object({
  review: RecapReviewSchema.nullable(),
  nextDueOn: LocalDateSchema.nullable(),
});
export type RecapDueResponse = z.infer<typeof RecapDueResponseSchema>;

export const RecapGetResponseSchema = z.object({
  review: RecapReviewSchema.extend({ isDue: z.boolean(), intervalDays: z.number().int() }),
});
export type RecapGetResponse = z.infer<typeof RecapGetResponseSchema>;

export const RecapListResponseSchema = z.object({
  reviews: z.array(RecapReviewSchema.extend({ isDue: z.boolean(), intervalDays: z.number().int() })),
});
export type RecapListResponse = z.infer<typeof RecapListResponseSchema>;

export const CompleteRecapRequestSchema = z
  .strictObject({
    correct: z.number().int().min(0).max(3),
    total: z.literal(3),
  })
  .refine((v) => v.correct <= v.total, { message: 'correct cannot exceed total', path: ['correct'] });
export type CompleteRecapRequest = z.infer<typeof CompleteRecapRequestSchema>;

export const CompleteRecapResponseSchema = z.object({
  xpAwarded: z.number().int().min(0),
  nextDueOn: LocalDateSchema,
  intervalDays: z.number().int().min(1),
  streak: StreakSchema,
});
export type CompleteRecapResponse = z.infer<typeof CompleteRecapResponseSchema>;
